<div class="row row--gutter">
  <div class="col-sm-12">
    <div class="card ad-model-container mb-0">
      <div class="ad-model-header d-flex justify-content-between align-items-center">
        <div class="d-block">
          <h4 class="mb-0">3PL Map</h4>
          <small class="vendor-name text-first-letter line-clamp-1">({{userData.fullName}})</small>
        </div>
        <div class="d-flex justify-content-center align-items-center">
          <div class="form-group ad-assign-method">
            <label class="control-label">3PL Assign Method</label>
            <ng-select class="custom-select" bindLabel="name" bindValue="name" placeholder="Select"
              (change)="thirdPartyMethod()" [(ngModel)]="dp_push_mechanisum" [searchable]="true" [clearable]="false"
              [items]="constant.dpAssignMethod">
            </ng-select>
          </div>
          <div class="rtb-checkbox ml-2">
            <div class="checkbox checkbox-primary">
              <input id="checkbox-primary-1" type="checkbox" [(ngModel)]="dp_rearrange_with_eta"
                (change)="checkValue($event)">
              <label for="checkbox-primary-1">Reassign with ETA</label>
            </div>
          </div>
          <button type="button" class="close ml-4" data-dismiss="modal" (click)="closeModal()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
      <div class="ad-delivery-partner-container" *ngIf="deliveryPartnerShow" dragula="DPM"
        [(dragulaModel)]="UserDeliveryPartnerMap" (dragulaModelChange)="interChangeList($event)">
        <div *ngFor="let dp of UserDeliveryPartnerMap; let i=index">
          <div class="card ad-delivery-main-card w-100"
            style="padding: 12px 36px 12px 12px; background-color: #FFFFFF; border: 1px solid #EEEEEE;">
            <div class="ad-partner-header d-flex flex-row justify-content-start align-items-center">
              <div class="ad-partner-logo">
                <img src="{{dp?.DeliveryPartner?.icon_url}}" style="width: 32px; object-fit: cover;"
                  (error)="dp.DeliveryPartner.icon_url = 'assets/images/favlogo.png';" alt="partner logo">
              </div>
              <h6 class="mb-0 ml-2">{{dp.DeliveryPartner.full_name}}</h6>
            </div>
            <div class="ad-partner-wrapper d-flex justify-content-end align-items-center">
              <div class="ad-timer-container d-flex flex-row justify-content-start align-items-center">
                <small class="mr-2">Waiting time (mins)</small>
                <input type="number" class="form-control" (keyup)="editFunction($event,i);" min="1"
                  oninput="this.value = !!this.value && Math.abs(this.value) >= 1 ? Math.abs(this.value) : null"
                  [(ngModel)]="dp.waiting_time_in_min" value="{{dp.waiting_time_in_min}}"
                  name="{{dp.DeliveryPartner.full_name}}" style="width: 70px; border-radius: 10px;">
              </div>

              <div class="ad-status-container" *ngIf="dp?.DeliveryPartner?.allow_cod_order" style="margin-left: 15px;">
                <div class="media custom--switch">
                  <div class="media-body icon-state">
                    <label class="switch">
                      <input type="checkbox" id="checkbox1{{i}}" (change)="allowCod($event,i)"
                        [checked]="dp.allow_cod" /><span class="switch-state"></span>
                    </label>
                  </div>
                  <label for="test" class="col-form-label m-l-10">COD</label>
                </div>
              </div>
              <div class="ad-status-container">
                <div class="media custom--switch">
                  <div class="media-body icon-state">
                    <label class="switch">
                      <input type="checkbox" id="checkbox{{i}}" (change)="activeAndInactive($event,i)"
                        [checked]="dp.status=='Active'?true:false" /><span class="switch-state"></span>
                    </label>
                  </div>
                  <label for="test" class="col-form-label m-l-10">Active</label>
                </div>
              </div>
              <div class="ad-status-container">
                <div class="ad-delete-icon" (click)="deleteDeliveryPartner(dp,i)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#8B8484">
                    <path fill="#8B8484"
                      d="M14.12 10.47L12 12.59l-2.13-2.12l-1.41 1.41L10.59 14l-2.12 2.12l1.41 1.41L12 15.41l2.12 2.12l1.41-1.41L13.41 14l2.12-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4zM6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM8 9h8v10H8z" />
                  </svg>
                </div>
              </div>
            </div>
            <div class="ad-drag-drop">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="#E7E8F3">
                <path fill="none" d="M0 0h24v24H0z" />
                <path
                  d="M16 13l6.964 4.062-2.973.85 2.125 3.681-1.732 1-2.125-3.68-2.223 2.15L16 13zm-2-7h2v2h5a1 1 0 0 1 1 1v4h-2v-3H10v10h4v2H9a1 1 0 0 1-1-1v-5H6v-2h2V9a1 1 0 0 1 1-1h5V6zM4 14v2H2v-2h2zm0-4v2H2v-2h2zm0-4v2H2V6h2zm0-4v2H2V2h2zm4 0v2H6V2h2zm4 0v2h-2V2h2zm4 0v2h-2V2h2z" />
              </svg>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center align-items-center flex-column"
          *ngIf="!UserDeliveryPartnerMap.length && deliveryPartnerShow">
          <img src="assets/images/no-delivery-partner.png" alt="no-delivery-partner">
          <p class="mt-3 mb-1">There is no delivery partners</p>
          <a class="mr-2 cursor-pointer d-flex justify-content-center align-items-center"
            (click)="deliveryPartnerAdd()">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="#229CD9">
              <path fill="none" d="M0 0h24v24H0z" />
              <path d="M11 11V5h2v6h6v2h-6v6h-2v-6H5v-2z" />
            </svg> Add delivery partners</a>
        </div>
      </div>
      <div class="card-footer text-right" *ngIf="deliveryPartnerShow">
        <button type="button" class="btn btn-secondary mr-2" (click)="deliveryPartnerAdd()">Add</button>
        <button type="button" class="btn btn-primary" *ngIf="UserDeliveryPartnerMap.length"
          (click)="updateData()">Update</button>
      </div>
      <form [formGroup]="dpFormGroup" (ngSubmit)="addDeliveryPartner()" class="mt-4">
        <div class="row mb-3" *ngIf="!deliveryPartnerShow">
          <div class="col">
            <div class="form-group">
              <label class="control-label">Delivery partner</label>
              <ng-select class="custom-select" bindLabel="full_name" bindValue="user_id" placeholder="Select"
                formControlName="delivery_partner_user_id" [searchable]="true" [items]="deliveryPartnerList">
              </ng-select>
              <div *ngIf="dpFormGroup.get('delivery_partner_user_id').invalid && submitted" class="error">
                <p class="mb-0 text-danger">Please choose delivery partner</p>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label class="control-label">Order waiting time(mins)</label>
              <input class="form-control" id="order-time" placeholder="Enter order time"
                formControlName="waiting_time_in_min" type="text">
              <div *ngIf="dpFormGroup.get('waiting_time_in_min').invalid && submitted" class="error">
                <p class="mb-0 text-danger">Order waiting time is required</p>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer text-right" *ngIf="!deliveryPartnerShow">
          <button type="button" class="btn btn-primary mr-2" (click)="backBtn()">Back</button>
          <button type="submit" class="btn btn-secondary">Save</button>
        </div>
      </form>
    </div>
  </div>
</div>